import classNames from 'classnames';
import { CSSProperties } from 'react';
import './OptionBtn.scss';
export interface OptionBtnProps {
  disabled?: boolean;
  id: string;
  onClick(val): void;
  phoneColNum?: number;
  selected?: boolean;
  size: CSSProperties['width'];
}

const OptionBtn: React.FC<OptionBtnProps> = ({
  children,
  disabled = false,
  id,
  onClick,
  phoneColNum,
  selected = false,
  size,
}) => (
  <button
    className={classNames('option-btn-container', {
      'college-branded-selected-option-button option-button-selected': selected,
      'college-branded-option-button': !selected,
      'option-button-three-col': phoneColNum === 3,
      'option-button-five-col': phoneColNum === 5,
    })}
    disabled={disabled && !selected}
    id={id}
    style={{ width: size }}
    onClick={(value) => onClick(value)}
  >
    {children}
  </button>
);

export default OptionBtn;
